// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NUqCj{padding:12px 0 16px 0}.vJgcT{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;min-height:240px;padding:24px 16px;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `NUqCj`,
	"empty": `vJgcT`
};
export default ___CSS_LOADER_EXPORT___;
